import { render, staticRenderFns } from "./elegant-img.vue?vue&type=template&id=77e01656&scoped=true"
import script from "./elegant-img.vue?vue&type=script&lang=js"
export * from "./elegant-img.vue?vue&type=script&lang=js"
import style0 from "./elegant-img.vue?vue&type=style&index=0&id=77e01656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e01656",
  null
  
)

export default component.exports